import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const optionalHttpUrl = z
    .string()
    .trim()
    .refine((value) => value === "" || /^https?:\/\//i.test(value), {
        message: "Enter a valid URL starting with http:// or https://",
    });

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    ShortName: z.string().optional().default(""),
    Description: z.string().optional().default(""),
    Website: optionalHttpUrl.optional().default(""),
    LogoUrl: z.string().optional().default(""),
    LogoFile: z.any().nullable().optional(),
    IsActive: z
        .union([z.boolean(), z.literal(0), z.literal(1), z.literal("0"), z.literal("1")])
        .transform((value) => value === true || value === 1 || value === "1")
        .optional()
        .default(true),
});

const newOrganizationResolver = zodResolver(schema);

export default newOrganizationResolver;
